import React, { useState, useEffect } from 'react';
import { Container, Nav, Navbar, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../img/logo.png';
import './css/Header.css';

function Header() {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setExpanded(false);
    }
  };

  return (
    <Navbar 
      expand="lg" 
      fixed="top"
      className={`navbar-custom ${scrolled ? 'navbar-scrolled' : ''} ${expanded ? 'navbar-expanded' : ''}`}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand">
          <img src={logo} alt="Blog Logo" className="logo-img" />
          {/* <span className="brand-text">TechBit</span> */}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              onClick={() => scrollToSection('home')}
              className="nav-link-custom"
            >
              Home
            </Nav.Link>
            <Nav.Link 
              onClick={() => scrollToSection('courses')}
              className="nav-link-custom"
            >
              Courses
            </Nav.Link>
            <Nav.Link   
              onClick={() => scrollToSection('about')}
              className="nav-link-custom"
            >
              About
            </Nav.Link>
            <Nav.Link 
              onClick={() => scrollToSection('services')}
              className="nav-link-custom"
            >
              Services
            </Nav.Link>
            <Nav.Link 
              onClick={() => scrollToSection('team')}
              className="nav-link-custom"
            >
              Team
            </Nav.Link>

             <Nav.Link 
              as={Link} to="/blog"
              className="nav-link-custom"
            >
              Blog
            </Nav.Link>

            <Nav.Link 
              onClick={() => scrollToSection('contact')}
              className="nav-link-custom"
            >
              Contact
            </Nav.Link>
            <Nav.Link 
              as={Link} to="/learning-zone"
              className="nav-link-custom"
            >
              Start Learning
            </Nav.Link>
          <NavDropdown 
              title="Tools" 
              id="tools-dropdown"
              className="tools-dropdown"
              menuVariant="dark"
            >
              <NavDropdown.Item onClick={() => window.location.href='/language-translator'}>
                Language Translator
              </NavDropdown.Item>
              {/* <NavDropdown.Item onClick={() => scrollToSection('color-picker')}>
                Color Picker
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => scrollToSection('unit-converter')}>
                Unit Converter
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={() => scrollToSection('qr-generator')}>
                QR Generator
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => scrollToSection('password-generator')}>
                Password Generator
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/all-tools">
                View All Tools →
              </NavDropdown.Item> */}
            </NavDropdown>

          </Nav>

          <div className="nav-buttons">
            <Button 
              variant="outline-light" 
              className="nav-button"
              as={Link} 
              to="/login"
            >
              Login
            </Button>
            <Button 
              variant="outline-light" 
              className="nav-button"
              as={Link}
              to="/signup"
            >
              Get Started
            </Button>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
